var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCameraMainCoral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4837,
    cy: 16.4837,
    r: 16.1444,
    fill: "#FF6262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1297 12.4868L13.7814 11.4342C13.9423 11.1745 14.1602 10.9616 14.4158 10.8143C14.6714 10.6671 14.9568 10.5901 15.2467 10.5901H18.0576C18.3475 10.5901 18.6329 10.6671 18.8885 10.8143C19.1441 10.9616 19.3621 11.1745 19.5229 11.4342L20.1746 12.4868H24.5776V22.9186H8.72672V12.4868H13.1297Z",
    stroke: "white",
    strokeWidth: 1.58036,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9456 19.9838C18.5668 19.9838 19.881 18.6696 19.881 17.0484C19.881 15.4273 18.5668 14.1131 16.9456 14.1131C15.3245 14.1131 14.0103 15.4273 14.0103 17.0484C14.0103 18.6696 15.3245 19.9838 16.9456 19.9838Z",
    stroke: "white",
    strokeWidth: 1.58036,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCameraMainCoral);
export default __webpack_public_path__ + "static/media/ic_camera_main_coral.4d076ae858dee6b5b83ed8f0d0f953d2.svg";
export { ForwardRef as ReactComponent };